import { Database, FileText, Shield, AlertTriangle, Activity, CalendarDays, Settings2, BarChart2, AlertCircle } from "lucide-react";

export const KPI_DATA = [
  {
    id: "total_apps",
    label: "Total Applications",
    value: 248,
    icon: Database,
    color: "#4f8ef7",
    borderColor: "border-border",
  },
  {
    id: "active_ssps",
    label: "Active SSP",
    value: 136,
    icon: Shield,
    color: "#a78bfa",
    borderColor: "border-border",
  },
  {
    id: "compliance_score",
    label: "Compliance Score",
    value: "87%",
    icon: FileText,
    color: "#34d399",
    borderColor: "border-border",
  },
  {
    id: "open_findings",
    label: "Open Findings",
    value: 1248,
    icon: AlertTriangle,
    color: "#f59e0b",
    borderColor: "border-border",
  },
  {
    id: "assessments_running",
    label: "Approved Assessments",
    value: 24,
    icon: Activity,
    color: "#22d3ee",
    borderColor: "border-border",
  },
];

export const PIPELINE_STAGES = [
  {
    id: "planned",
    label: "Planned",
    count: 3,
    pct: 16,
    color: "#4f8ef7",
    bgColor: "#162040",
    dotColor: "#4f8ef7",
    icon: CalendarDays,
  },
  {
    id: "in_progress",
    label: "In Progress",
    count: 8,
    pct: 42,
    color: "#f97316",
    bgColor: "#2a1500",
    dotColor: "#f97316",
    icon: Settings2,
  },
  {
    id: "review",
    label: "Review",
    count: 2,
    pct: 11,
    color: "#22d3ee",
    bgColor: "#082830",
    dotColor: "#22d3ee",
    icon: BarChart2,
  },
  {
    id: "completed",
    label: "Completed",
    count: 5,
    pct: 26,
    color: "#34d399",
    bgColor: "#082818",
    dotColor: "#34d399",
    icon: Shield,
  },
  {
    id: "overdue",
    label: "Overdue",
    count: 1,
    pct: 5,
    color: "#ef4444",
    bgColor: "#280a0a",
    dotColor: "#ef4444",
    icon: AlertCircle,
  },
];

/* ── Compliance by Framework — mock data (no API endpoint) ──────────── */
export const FRAMEWORKS = [
  { name: "IM8",     pct: 34, color: "#a78bfa" },
  { name: "TRMG", pct: 22, color: "#4f8ef7" },
  { name: "NIST 800-53",       pct: 18, color: "#22d3ee" },
  { name: "DORA",   pct: 14, color: "#34d399" },
  { name: "ISO 27001",        pct: 12,  color: "#f59e0b" },
];

export const DONUT_TOTAL = 7;

/* ── Exported types (used by main dashboard for API-driven state) ─── */
export type KpiItem          = (typeof KPI_DATA)[0] & { value: number | string };
export type PipelineStageItem = {
  id: string; label: string; count: number; pct: number;
  color: string; bgColor: string; dotColor: string;
  icon: React.ElementType;
};
export type FrameworkItem    = { name: string; pct: number; color: string };
export type RiskAppItem      = { name: string; findings: number; severity: string; complianceScore: number };
export type PoamStatusItem   = { label: string; count: number; color: string };
